module.exports = ELEMENT;


//////////////////
// WEBPACK FOOTER
// external "ELEMENT"
// module id = 431
// module chunks = 1